import { render, staticRenderFns } from "./MoAuthorizePage.vue?vue&type=template&id=1f5361ba&scoped=true&"
import script from "./MoAuthorizePage.vue?vue&type=script&lang=js&"
export * from "./MoAuthorizePage.vue?vue&type=script&lang=js&"
import style0 from "./MoAuthorizePage.vue?vue&type=style&index=0&id=1f5361ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5361ba",
  null
  
)

export default component.exports